// extracted by mini-css-extract-plugin
export default {"agreementContainer":"FeedBackForm_agreementContainer__kFSzy","agreementCard":"FeedBackForm_agreementCard__t3S8T"};